(function () {
  "use strict";

  var root = document.getElementById("canedica-intake-v2");
  var warning = document.getElementById("canedica-v2-cart-warning");
  if (!root || !warning) return;

  var frame = root.querySelector("[data-canedica-v2-frame]");
  var status = root.querySelector("[data-canedica-v2-status]");
  var warningTitle = warning.querySelector("#canedica-v2-warning-title");
  var warningCopy = warning.querySelector("[data-canedica-v2-warning-copy]");
  var enabled = root.dataset.enabled === "true";
  var sessionToken = "";
  var startInProgress = false;
  var checkoutInProgress = false;

  function cartRequest(path, options) {
    return fetch(path, Object.assign({
      credentials: "same-origin",
      headers: { "Accept": "application/json", "Content-Type": "application/json" }
    }, options || {})).then(function (response) {
      if (!response.ok) throw new Error("cart_request_failed");
      return response.json();
    });
  }

  function getCart() {
    return cartRequest("/cart.js");
  }

  function updateCart(attributes) {
    return cartRequest("/cart/update.js", {
      method: "POST",
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function isV2Cart(cart) {
    var attributes = cart && cart.attributes ? cart.attributes : {};
    return attributes.canedica_flow_version === "v2" && !!attributes.canedica_v2_session_token;
  }

  function isV2AnamnesisCompleted(cart) {
    if (!isV2Cart(cart)) return false;
    var attributes = cart.attributes || {};
    return String(attributes.canedica_v2_completed_session_token || "") === String(attributes.canedica_v2_session_token || "");
  }

  function applyV2DocumentState(cart) {
    document.documentElement.classList.toggle("canedica-intake-v2-active", isV2Cart(cart));
  }

  function closeIntake() {
    root.hidden = true;
    document.documentElement.classList.remove("canedica-modal-open");
  }

  function openIntake(url) {
    root.hidden = false;
    document.documentElement.classList.add("canedica-modal-open");
    status.hidden = false;
    frame.hidden = true;
    frame.onload = function () {
      status.hidden = true;
      frame.hidden = false;
    };
    frame.src = url;
  }

  function showStartError(message) {
    root.hidden = false;
    document.documentElement.classList.add("canedica-modal-open");
    frame.hidden = true;
    status.hidden = false;
    status.textContent = message;
  }

  function loginAndReturn() {
    var returnUrl = new URL(window.location.href);
    returnUrl.searchParams.set("canedica_v2_start", "1");
    var loginUrl = root.dataset.loginUrl || "/account/login";
    window.location.href = loginUrl + (loginUrl.indexOf("?") === -1 ? "?" : "&") + "return_to=" + encodeURIComponent(returnUrl.pathname + returnUrl.search);
  }

  function storefrontReturnUrl() {
    var fallbackPath = "/collections/all?filter.v.availability=1";
    try {
      var configured = new URL(root.dataset.returnUrl || fallbackPath, window.location.origin);
      return window.location.origin + configured.pathname + configured.search + configured.hash;
    } catch (_) {
      return window.location.origin + fallbackPath;
    }
  }

  function prepareV2Cart(token, existingCart) {
    var existingAttributes = existingCart && existingCart.attributes ? existingCart.attributes : {};
    var resumesSameCart = isV2Cart(existingCart) && String(existingAttributes.canedica_v2_session_token) === String(token);
    var shouldClear = !resumesSameCart && existingCart && Number(existingCart.item_count || 0) > 0;

    var clearPromise = shouldClear
      ? cartRequest("/cart/clear.js", { method: "POST", body: JSON.stringify({}) })
      : Promise.resolve(existingCart);

    return clearPromise.then(function () {
      return updateCart({
        canedica_flow_version: "v2",
        canedica_rx_flow: "intake_v2",
        canedica_v2_session_token: token,
        canedica_v2_completed_session_token: resumesSameCart
          ? String(existingAttributes.canedica_v2_completed_session_token || "")
          : "",
        canedica_session_token: token,
        canedica_rx_choice: "",
        canedica_birthdate: "",
        canedica_v2_checkout_checked_at: ""
      });
    });
  }

  function startV2() {
    if (!enabled) return;
    if (startInProgress) return;
    if (root.dataset.customerAuthenticated !== "true") {
      loginAndReturn();
      return;
    }

    startInProgress = true;
    status.textContent = "Verbindung zu Canedica wird hergestellt …";
    root.hidden = false;
    document.documentElement.classList.add("canedica-modal-open");

    var startUrl = new URL(root.dataset.startPath || "/apps/canedica-rezeptservice", window.location.origin);
    startUrl.searchParams.set("flow", "v2");
    startUrl.searchParams.set("response", "json");
    // A unique URL prevents browsers from reusing a previously cached permanent
    // redirect while also keeping session-start responses out of shared caches.
    startUrl.searchParams.set("request_id", Date.now().toString());
    startUrl.searchParams.set("return_url", storefrontReturnUrl());

    Promise.all([
      fetch(startUrl.pathname + startUrl.search, { credentials: "same-origin", headers: { "Accept": "application/json" } }).then(function (response) {
        if (response.status === 401) {
          loginAndReturn();
          throw new Error("login_required");
        }
        if (!response.ok) throw new Error("session_start_failed");
        return response.json();
      }),
      getCart()
    ]).then(function (results) {
      var session = results[0];
      var cart = results[1];
      if (!session || !session.token || !session.startUrl) throw new Error("invalid_session_response");
      sessionToken = String(session.token);
      return prepareV2Cart(sessionToken, cart).then(function (updatedCart) {
        applyV2DocumentState(updatedCart);
        openIntake(session.startUrl);
      });
    }).catch(function (error) {
      if (error && error.message === "login_required") {
        closeIntake();
        return;
      }
      showStartError("Die Rezeptanfrage konnte gerade nicht gestartet werden. Bitte versuche es erneut.");
    }).finally(function () {
      startInProgress = false;
    });
  }

  function isV2StartLink(link) {
    if (!enabled) return false;
    if (!link || !link.href) return false;
    if (link.hasAttribute("data-canedica-intake-v2-start")) return true;
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.pathname.indexOf("/api/integrations/shopify/anamnesis-first/direct-start") !== -1) return true;
      var label = (link.textContent || "").trim().toLowerCase();
      return /(^|\.)canedica\.de$/.test(url.hostname) && label.indexOf("rezept anfragen") !== -1;
    } catch (_) {
      return false;
    }
  }

  function normalizeV2StartLinks() {
    if (!enabled) return;
    var cleanStartUrl = new URL(window.location.href);
    cleanStartUrl.search = "";
    cleanStartUrl.hash = "";
    cleanStartUrl.searchParams.set("canedica_v2_start", "1");
    document.querySelectorAll("a").forEach(function (link) {
      if (!isV2StartLink(link)) return;
      link.href = cleanStartUrl.toString();
      link.removeAttribute("target");
      link.setAttribute("data-canedica-intake-v2-start", "");
    });
  }

  function showCartWarning(cart) {
    var grams = Number(cart.item_count || 0);
    if (grams < 10) {
      warningTitle.textContent = "Mindestbestellmenge für die Rezeptanfrage";
      warningCopy.replaceChildren(
        document.createTextNode("Dieser integrierte Ablauf steht für Warenkörbe ab "),
        Object.assign(document.createElement("strong"), { textContent: "10 g" }),
        document.createTextNode(" zur Verfügung. Bitte passe deinen Warenkorb an oder wähle einen anderen Bestellweg.")
      );
    } else {
      warningTitle.textContent = "Höchstmenge für die Rezeptanfrage";
      warningCopy.textContent = "Aktuell sind " + grams + " g im Warenkorb. Pro Rezeptanfrage sind höchstens 100 g möglich.";
    }
    warning.hidden = false;
    document.documentElement.classList.add("canedica-modal-open");
  }

  function validateV2Checkout(cart) {
    var grams = Number(cart.item_count || 0);
    var productCount = new Set((cart.items || []).map(function (item) { return String(item.product_id || item.variant_id); })).size;
    return grams >= 10 && grams <= 100 && productCount >= 1;
  }

  function resumeV2Intake(cart) {
    var attributes = cart && cart.attributes ? cart.attributes : {};
    var token = String(attributes.canedica_v2_session_token || "");
    if (!token) {
      showStartError("Die Rezeptanfrage konnte nicht fortgesetzt werden. Bitte starte sie erneut.");
      return;
    }
    sessionToken = token;
    var intakeOrigin = root.dataset.intakeOrigin || "https://www.canedica.de";
    openIntake(intakeOrigin + "/patient/shopify-intake-v2/" + encodeURIComponent(token));
  }

  function continueCheckout(form, href) {
    checkoutInProgress = true;
    updateCart({ canedica_v2_checkout_checked_at: new Date().toISOString() })
      .catch(function () { return null; })
      .finally(function () {
        if (form) {
          HTMLFormElement.prototype.submit.call(form);
        } else {
          window.location.href = href || "/checkout";
        }
      });
  }

  function interceptCheckout(form, href) {
    if (checkoutInProgress) return;
    getCart().then(function (cart) {
      applyV2DocumentState(cart);
      if (!isV2Cart(cart)) {
        checkoutInProgress = true;
        if (form) HTMLFormElement.prototype.submit.call(form);
        else window.location.href = href || "/checkout";
        return;
      }
      if (!isV2AnamnesisCompleted(cart)) {
        resumeV2Intake(cart);
        return;
      }
      if (!validateV2Checkout(cart)) {
        showCartWarning(cart);
        return;
      }
      continueCheckout(form, href);
    }).catch(function () {
      if (document.documentElement.classList.contains("canedica-intake-v2-active")) {
        showStartError("Der Warenkorb konnte nicht geprüft werden. Bitte lade die Seite neu und versuche es erneut.");
        return;
      }
      checkoutInProgress = true;
      if (form) HTMLFormElement.prototype.submit.call(form);
      else window.location.href = href || "/checkout";
    });
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest("a");
    if (isV2StartLink(link)) {
      event.preventDefault();
      startV2();
      return;
    }

    var checkoutLink = event.target.closest('a[href^="/checkout"], a[href*="/checkout?"]');
    if (checkoutLink && document.documentElement.classList.contains("canedica-intake-v2-active")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      interceptCheckout(null, checkoutLink.href);
    }
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var submitter = event.submitter;
    var isCheckout =
      form.matches(".cart__recap, #mini-cart-form") ||
      (submitter && String(submitter.name || "").toLowerCase() === "checkout") ||
      !!form.querySelector('[name="checkout"], [name="Checkout"]');
    if (!isCheckout || !document.documentElement.classList.contains("canedica-intake-v2-active")) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    interceptCheckout(form, null);
  }, true);

  root.querySelectorAll("[data-canedica-v2-close]").forEach(function (button) {
    button.addEventListener("click", closeIntake);
  });
  warning.querySelectorAll("[data-canedica-v2-warning-close]").forEach(function (button) {
    button.addEventListener("click", function () {
      warning.hidden = true;
      document.documentElement.classList.remove("canedica-modal-open");
    });
  });

  window.addEventListener("message", function (event) {
    if (event.origin !== "https://www.canedica.de" && event.origin !== "https://canedica.de") return;
    var data = event.data || {};
    if (data.type !== "canedica:shopify-intake-v2-completed") return;
    if (!sessionToken || data.sessionToken !== sessionToken) return;
    updateCart({ canedica_v2_completed_session_token: sessionToken }).then(function (cart) {
      applyV2DocumentState(cart);
      closeIntake();
      window.location.href = storefrontReturnUrl();
    }).catch(function () {
      showStartError("Der Abschluss konnte gerade nicht mit dem Warenkorb verknüpft werden. Bitte versuche es erneut.");
    });
  });

  getCart().then(applyV2DocumentState).catch(function () {});
  normalizeV2StartLinks();

  var params = new URLSearchParams(window.location.search);
  if (enabled && params.get("canedica_v2_start") === "1" && root.dataset.customerAuthenticated === "true") {
    params.delete("canedica_v2_start");
    window.history.replaceState({}, "", window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash);
    startV2();
  }

  window.CanedicaIntakeV2 = { start: startV2 };
})();
